module.exports = __webpack_public_path__ + "img/f6365e69c0964ca68783152e25136285--clock-tattoos-clocks.jpg";